import React, { useState } from 'react';
import { API, authFetch } from '../utils/api';

// 매입 결정 모달 — 등록증 OCR / 수기 입력 / 바로 매입
// 최종적으로 POST /eval/orders/:id/decide { purchase_price, export_price_usd, buyer_name, buyer_country, registrationData? }

function EvalDecideModal(props){
  var order=props.order||{};
  var onClose=props.onClose;
  var onSuccess=props.onSuccess;

  var[mode,setMode]=useState('select'); // select | ocr | manual | quick
  var[regData,setRegData]=useState({
    carNo:order.car_number||'',
    vin:'',
    carType:order.car_model||'',
    usage2:'자가용',
    owner:'',
    ownerAddr:'',
    ownerId:'',
    regDate:'',
    mileage:order.car_mileage||'',
    fuel:order.car_fuel||'',
    displacement:'',
    color:order.car_color||''
  });
  var[purchasePrice,setPurchasePrice]=useState('');
  var[exportPriceUsd,setExportPriceUsd]=useState('');
  var[buyerName,setBuyerName]=useState('');
  var[buyerCountry,setBuyerCountry]=useState('UAE');
  var[ocrLoading,setOcrLoading]=useState(false);
  var[ocrError,setOcrError]=useState('');
  var[submitting,setSubmitting]=useState(false);
  var[submitError,setSubmitError]=useState('');

  var updateField=function(key,value){
    setRegData(function(prev){var next=Object.assign({},prev);next[key]=value;return next});
  };

  var handleFile=function(e){
    var file=e.target.files&&e.target.files[0];
    if(!file)return;
    setOcrLoading(true);
    setOcrError('');
    var fd=new FormData();
    fd.append('image',file);
    authFetch(API+'/ocr',{method:'POST',body:fd})
      .then(function(r){return r.json()})
      .then(function(d){
        if(d&&d.success&&d.data){
          var o=d.data;
          setRegData(function(prev){
            return {
              carNo:o.carNo||prev.carNo,
              vin:o.vin||prev.vin,
              carType:o.carType||prev.carType,
              usage2:o.usage2||'자가용',
              owner:o.owner||'',
              ownerAddr:o.ownerAddr||'',
              ownerId:o.ownerId||'',
              regDate:o.regDate||'',
              mileage:o.mileage||prev.mileage,
              fuel:o.fuel||prev.fuel,
              displacement:o.displacement||'',
              color:prev.color
            };
          });
        }else{
          setOcrError((d&&d.error)||'OCR 인식 실패');
        }
      })
      .catch(function(){setOcrError('서버 연결 실패')})
      .then(function(){setOcrLoading(false);try{e.target.value=''}catch(er){}});
  };

  var handleSubmit=function(){
    if(submitting)return;
    var priceNum=parseInt(String(purchasePrice).replace(/[^0-9]/g,''))||0;
    if(priceNum<=0){setSubmitError('매입가를 입력해주세요');return}
    setSubmitting(true);
    setSubmitError('');
    var body={
      purchase_price:priceNum,
      export_price_usd:parseInt(String(exportPriceUsd).replace(/[^0-9]/g,''))||null,
      buyer_name:buyerName,
      buyer_country:buyerCountry
    };
    if(mode==='ocr'||mode==='manual'){
      var payload={};
      Object.keys(regData).forEach(function(k){if(regData[k]!==''&&regData[k]!=null)payload[k]=regData[k]});
      if(Object.keys(payload).length>0)body.registrationData=payload;
    }
    authFetch(API+'/eval/orders/'+order.id+'/decide',{method:'POST',body:JSON.stringify(body)})
      .then(function(r){return r.json()})
      .then(function(d){
        if(d&&d.success){
          if(onSuccess)onSuccess(d.data||{});
        }else{
          setSubmitError((d&&d.error)||'매입 처리 실패');
        }
      })
      .catch(function(){setSubmitError('서버 연결 실패')})
      .then(function(){setSubmitting(false)});
  };

  // ────────── 필드 렌더 헬퍼 ──────────
  var labelStyle={display:'block',fontSize:10,color:'#888',marginBottom:3,fontWeight:600};
  var inputStyle={width:'100%',boxSizing:'border-box',padding:'8px 10px',border:'1px solid #e0dfda',borderRadius:6,fontSize:13,outline:'none'};
  var Field=function(p){return (
    <div>
      <label style={labelStyle}>{p.label}{p.req&&<span style={{color:'#E24B4A'}}> *</span>}</label>
      <input type={p.type||'text'} value={p.value||''} onChange={function(e){updateField(p.k,e.target.value)}} placeholder={p.placeholder||''} disabled={submitting} style={inputStyle}/>
    </div>
  )};

  var renderRegForm=function(){
    return (
      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8}}>
        <Field k="carNo" label="차량번호" req={true} value={regData.carNo}/>
        <Field k="vin" label="차대번호" value={regData.vin}/>
        <Field k="carType" label="차종" value={regData.carType}/>
        <Field k="regDate" label="최초등록일" placeholder="2026-01-15" value={regData.regDate}/>
        <Field k="owner" label="소유자" value={regData.owner}/>
        <Field k="ownerId" label="주민번호 (암호화 저장)" placeholder="890101-1234567" value={regData.ownerId}/>
        <div style={{gridColumn:'1/-1'}}><Field k="ownerAddr" label="소유자 주소" value={regData.ownerAddr}/></div>
        <Field k="mileage" label="주행거리 (km)" type="text" value={regData.mileage}/>
        <Field k="fuel" label="연료" value={regData.fuel}/>
        <Field k="displacement" label="배기량 (cc)" value={regData.displacement}/>
        <Field k="color" label="색상" value={regData.color}/>
      </div>
    );
  };

  var renderPurchaseFields=function(){
    var expectedProfit=0;
    var pp=parseInt(String(purchasePrice).replace(/[^0-9]/g,''))||0;
    var ex=parseInt(String(exportPriceUsd).replace(/[^0-9]/g,''))||0;
    if(pp>0&&ex>0)expectedProfit=(ex*1380-pp)/10000;
    return (
      <div style={{padding:'12px',background:'#fff7ed',border:'1px solid #fed7aa',borderRadius:8,marginTop:12}}>
        <div style={{fontSize:11,fontWeight:700,color:'#9a3412',marginBottom:8}}>💰 매입/수출 정보</div>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8}}>
          <div>
            <label style={labelStyle}>매입가 (원) <span style={{color:'#E24B4A'}}>*</span></label>
            <input type="text" inputMode="numeric" value={purchasePrice?Number(String(purchasePrice).replace(/[^0-9]/g,'')||0).toLocaleString():''}
              onChange={function(e){setPurchasePrice(e.target.value.replace(/[^0-9]/g,''));setSubmitError('')}}
              placeholder="3000000" disabled={submitting}
              style={Object.assign({},inputStyle,{textAlign:'right',fontWeight:700})}/>
          </div>
          <div>
            <label style={labelStyle}>수출가 (USD)</label>
            <input type="text" inputMode="numeric" value={exportPriceUsd?Number(String(exportPriceUsd).replace(/[^0-9]/g,'')||0).toLocaleString():''}
              onChange={function(e){setExportPriceUsd(e.target.value.replace(/[^0-9]/g,''))}}
              placeholder="3500" disabled={submitting}
              style={Object.assign({},inputStyle,{textAlign:'right'})}/>
          </div>
          <div>
            <label style={labelStyle}>바이어</label>
            <input value={buyerName} onChange={function(e){setBuyerName(e.target.value)}} disabled={submitting} style={inputStyle}/>
          </div>
          <div>
            <label style={labelStyle}>수출국</label>
            <select value={buyerCountry} onChange={function(e){setBuyerCountry(e.target.value)}} disabled={submitting} style={inputStyle}>
              <option>UAE</option><option>사우디</option><option>요르단</option><option>리비아</option><option>기타</option>
            </select>
          </div>
        </div>
        {expectedProfit!==0&&(
          <div style={{marginTop:8,padding:'6px 10px',background:'#fff',borderRadius:6,fontSize:12}}>
            예상 수익: <strong style={{color:expectedProfit>0?'#1D9E75':'#E24B4A',fontSize:15}}>{expectedProfit.toFixed(1)}만원</strong>
          </div>
        )}
      </div>
    );
  };

  // ────────── 메인 렌더 ──────────
  return (
    <div onClick={function(){if(!submitting)onClose()}}
      style={{position:'fixed',inset:0,background:'rgba(15,23,42,0.6)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9998,padding:16}}>
      <div onClick={function(e){e.stopPropagation()}}
        style={{background:'#fff',borderRadius:16,width:'100%',maxWidth:560,maxHeight:'92vh',display:'flex',flexDirection:'column',boxShadow:'0 20px 60px rgba(0,0,0,0.3)'}}>

        {/* 헤더 */}
        <div style={{padding:'14px 20px',borderBottom:'1px solid #e5e7eb',display:'flex',alignItems:'center',justifyContent:'space-between',flexShrink:0}}>
          <div style={{display:'flex',alignItems:'center',gap:8}}>
            {mode!=='select'&&(
              <button onClick={function(){if(!submitting)setMode('select')}} disabled={submitting}
                style={{background:'none',border:'none',fontSize:18,cursor:submitting?'wait':'pointer',color:'#475569',padding:0}}>←</button>
            )}
            <div style={{fontSize:15,fontWeight:800,color:'#1B3A5C'}}>
              🚗 매입 결정 {order.car_model?'— '+order.car_model:''} {order.car_number||''}
            </div>
          </div>
          <button onClick={onClose} disabled={submitting}
            style={{background:'none',border:'none',fontSize:20,cursor:submitting?'wait':'pointer',color:'#94a3b8',padding:4}}>✕</button>
        </div>

        {/* 본문 */}
        <div style={{flex:1,overflowY:'auto',padding:'18px 20px'}}>
          {mode==='select'&&(
            <div>
              <div style={{fontSize:13,color:'#475569',marginBottom:18,textAlign:'center',lineHeight:1.6}}>
                차량등록증 정보를 어떻게 입력하시겠어요?
              </div>
              <div style={{display:'flex',flexDirection:'column',gap:10}}>
                <button onClick={function(){setMode('ocr')}}
                  style={{padding:'16px',background:'#eff6ff',border:'2px solid #1B3A5C',borderRadius:10,cursor:'pointer',textAlign:'left',display:'flex',alignItems:'center',gap:14}}>
                  <span style={{fontSize:32}}>📷</span>
                  <div style={{flex:1}}>
                    <div style={{fontSize:14,fontWeight:800,color:'#1B3A5C'}}>등록증 OCR 인식</div>
                    <div style={{fontSize:11,color:'#64748b',marginTop:2}}>사진 업로드 → 자동 인식 → 확인/수정</div>
                  </div>
                </button>
                <button onClick={function(){setMode('manual')}}
                  style={{padding:'16px',background:'#fff',border:'2px solid #cbd5e1',borderRadius:10,cursor:'pointer',textAlign:'left',display:'flex',alignItems:'center',gap:14}}>
                  <span style={{fontSize:32}}>✏️</span>
                  <div style={{flex:1}}>
                    <div style={{fontSize:14,fontWeight:800,color:'#475569'}}>수기 입력</div>
                    <div style={{fontSize:11,color:'#64748b',marginTop:2}}>검차 정보 자동 채움 + 추가 필드 직접 입력</div>
                  </div>
                </button>
                <button onClick={function(){setMode('quick')}}
                  style={{padding:'16px',background:'#fff',border:'1px dashed #cbd5e1',borderRadius:10,cursor:'pointer',textAlign:'left',display:'flex',alignItems:'center',gap:14}}>
                  <span style={{fontSize:32}}>🚀</span>
                  <div style={{flex:1}}>
                    <div style={{fontSize:14,fontWeight:700,color:'#64748b'}}>바로 매입</div>
                    <div style={{fontSize:10,color:'#94a3b8',marginTop:2}}>검차에 등록증 사진이 있으면 서버가 자동 OCR (기존 방식)</div>
                  </div>
                </button>
              </div>
            </div>
          )}

          {mode==='ocr'&&(
            <div>
              <div style={{padding:'12px',background:'#eff6ff',border:'1px dashed #bfdbfe',borderRadius:10,marginBottom:14,textAlign:'center'}}>
                <label style={{display:'block',cursor:ocrLoading?'wait':'pointer'}}>
                  <input type="file" accept="image/*,application/pdf" onChange={handleFile} disabled={ocrLoading||submitting} style={{display:'none'}}/>
                  <div style={{fontSize:36,marginBottom:6}}>{ocrLoading?'⏳':'📷'}</div>
                  <div style={{fontSize:13,fontWeight:700,color:'#1B3A5C'}}>{ocrLoading?'OCR 인식 중...':'등록증 사진 선택'}</div>
                  <div style={{fontSize:10,color:'#64748b',marginTop:4}}>JPG/PNG/PDF 가능</div>
                </label>
              </div>
              {ocrError&&(
                <div style={{padding:'8px 10px',background:'#fef2f2',border:'1px solid #fecaca',borderRadius:6,fontSize:11,color:'#dc2626',marginBottom:10}}>
                  ⚠ {ocrError}
                </div>
              )}
              <div style={{fontSize:11,fontWeight:700,color:'#475569',marginBottom:8}}>🔎 인식 결과 (확인 후 수정 가능)</div>
              {renderRegForm()}
            </div>
          )}

          {mode==='manual'&&(
            <div>
              <div style={{padding:'10px 12px',background:'#f8fafc',borderRadius:6,fontSize:11,color:'#64748b',marginBottom:12,lineHeight:1.5}}>
                ℹ️ 검차 정보가 자동 채움되었습니다. 등록증 정보(소유자, 주민번호, 주소 등)는 직접 입력해주세요.
              </div>
              {renderRegForm()}
            </div>
          )}

          {mode==='quick'&&(
            <div style={{padding:'16px',background:'#f8fafc',borderRadius:8,fontSize:12,color:'#475569',lineHeight:1.7,marginBottom:8}}>
              🚀 <strong>바로 매입</strong><br/>
              차량 정보 입력 없이 즉시 매입 확정합니다. 검차 시 업로드된 등록증 사진이 있으면 서버가 자동으로 OCR하여 차량 정보를 채웁니다.
            </div>
          )}

          {mode!=='select'&&renderPurchaseFields()}

          {submitError&&(
            <div style={{padding:'10px 12px',background:'#fef2f2',border:'1px solid #fecaca',borderRadius:8,fontSize:12,color:'#dc2626',marginTop:12}}>
              {submitError}
            </div>
          )}
        </div>

        {/* 하단 액션 */}
        {mode!=='select'&&(
          <div style={{padding:'14px 20px',borderTop:'1px solid #e5e7eb',flexShrink:0}}>
            <button onClick={handleSubmit} disabled={submitting||ocrLoading}
              style={{width:'100%',padding:'13px 0',background:(submitting||ocrLoading)?'#cbd5e1':'#D85A30',color:'#fff',border:'none',borderRadius:8,fontSize:14,fontWeight:800,cursor:submitting?'wait':'pointer'}}>
              {submitting?'처리 중...':'✓ 매입 확정 → AUTODEX 차량 등록'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default EvalDecideModal;
